import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './NavBar.module.css';
import { AiOutlineMenuUnfold, AiOutlineClose } from "react-icons/ai";

const NavBar = () => {
    const [navBarOpen, setNavBarOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [windowDimension, setWindowDimension] = useState({
        width: window.innerWidth,
        height: window.innerHeight, 
    });

    const detectDimension = () => {
        setWindowDimension({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };

    const handleScroll = () => {
        if (window.scrollY > 50) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('resize', detectDimension);
        window.addEventListener('scroll', handleScroll);
        
        windowDimension.width > 768 && setNavBarOpen(false);
        
        return () => {
            window.removeEventListener('resize', detectDimension);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [windowDimension]);

    const links = [
        {
            id: 1,
            link: 'Home',
            path: '/home'
        },
        {
            id: 2,
            link: 'Services',
            path: '/services'
        },
        {
            id: 3,
            link: 'Contact',
            path: '/contact'
        },
        {
            id: 4,
            link: 'How do we work?',
            path: '/how-we-work'
        },
        {
            id: 5,
            link: 'Did you know!',
            path: '/Know' 
        },
    ];

    return (
        <div className={styles.container}>
            <div className={`${styles.navBar} ${scrolled ? styles.navBarScrolled : ''}`}>
                <div className={styles.navBarContent}>
                    {/* Opción 1: Con react-icons (si funciona) */}
                    <AiOutlineMenuUnfold 
                        onClick={() => setNavBarOpen(!navBarOpen)} 
                        size={25}
                        className={styles.menuIcon}
                        aria-label="Abrir menú de navegación"
                    />
                    
                    {/* Opción 2: Ícono CSS alternativo (descomenta si react-icons no funciona) */}
                    {/*
                    <div 
                        onClick={() => setNavBarOpen(!navBarOpen)}
                        className={styles.hamburgerIcon}
                        aria-label="Abrir menú de navegación"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    */}
                    
                    <div className={styles.brandContainer}>
                        <Link to="/home" className={styles.logo}>
                            QS | LOGISTICS
                        </Link>

                        <div className={styles.logoContainer}>
                           <Link to='/home'> 
                            <img 
                                src={`${process.env.PUBLIC_URL}/QS LOGISTICS.png`}
                                alt="Logo QS Logistics"
                                className={styles.navbarLogo}
                                onError={() => console.error('❌ Error cargando logo QS LOGISTIC.png')}
                                onLoad={() => console.log('✅ Logo cargado correctamente')}
                            />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className={`${styles.slideMenu} ${navBarOpen ? styles.menuOpen : ''}`}>
                <AiOutlineClose 
                    onClick={() => setNavBarOpen(false)} 
                    color='#ffffff' 
                    size={25}
                    className={styles.closeIcon}
                    aria-label="Cerrar menú de navegación"
                />
                
                <ul className={styles.menuLinks}>
                    {links.map((item, index) => (
                        <div 
                            key={item.id} 
                            className={`${styles.menuItemContainer} ${navBarOpen ? styles.menuItemVisible : ''}`}
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            <Link  
                                onClick={() => setNavBarOpen(false)}
                                to={item.path}
                                className={styles.navLink}
                            > 
                                {item.link} 
                            </Link>
                        </div>
                    ))}
                </ul>
            </div>
            
            {navBarOpen && (
                <div 
                    className={styles.overlay} 
                    onClick={() => setNavBarOpen(false)}
                    aria-label="Cerrar menú haciendo clic fuera"
                />
            )}
        </div>
    );
};

export default NavBar;